import { EventTag } from '../types';
import { medtechApi } from './index';

const tagsApi = {
  async getAllTags(company: number): Promise<EventTag[] | undefined> {
    const res = await medtechApi.get(`/tags?company_id=${company}`);
    return res.data as EventTag[];
  },
};

export default tagsApi;
